import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { cloneDeep } from 'src/ep-utils';
import { ContractState } from '../../../../../core/models/proprietary/contract/contract.state';
import { ProfileState } from '../../../../../core/models/proprietary/contract/profile.state';
import { AppService } from '../../../../../core/services/proprietary/app.service';
import { DataSourceStatus } from '../../../../../core/services/proprietary/datasource';

@Component({
    standalone: false,
    selector: 'contract-profile-search-dialog',
    templateUrl: './contract-profile-search-dialog.component.html',
    providers: [DataService]
})
export class ContractProfileSearchDialogComponent extends SearchDialogComponent {
    constructor(
        private injector: Injector,
        private activeModal: NgbActiveModal,
        private store: Store,
        public app: AppService
    ) {
        super(injector);
    }

    currentProfiles: any;

    profiles: any = [];
    dsCollectionSub: Subscription;

    canViewDLData: string = 'Y';
    canViewDOBData: string = 'Y';

    profileLabel: string = 'Profile';

    public modelChild = {
        searchReady: false,
        contractID: ''
    };

    initialize(): boolean {
        this.profileLabel = this.model.criteria.profileLabel || 'Profile';
        //Delete since profileLabel isn't true criteria for the Collection. Used to pass dynamic label to dialog.
        delete this.model.criteria.profileLabel;

        this.hasAccessToControlledData();
        this.parentActiveModal = this.activeModal;
        this.objectType = 'DBQuery';
        this.model.title = 'Select ' + this.profileLabel;
        this.model.criteria.Procedure_Name = 'epx_tempcontractprofilesearch';

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        this.modelChild.contractID = this.store.selectSnapshot(ContractState.currentID);
        this.currentProfiles = cloneDeep(this.store.selectSnapshot(ProfileState.profiles));
        for (var i in this.currentProfiles) {
            this.currentProfiles[i].Current_Contract = true;
            this.currentProfiles[i].Contract_Num = 'CURRENT';
            if (this.currentProfiles[i].Edit_Status == 'D') {
                delete this.currentProfiles[i];
            }
        }

        this.dsCollectionSub = this.dsCollection.status$.subscribe((status: DataSourceStatus) => {
            if (status) {
                if (status == DataSourceStatus.Ready) {
                    this.buildProfileList();
                }
            }
        });

        return true;
    }

    buildProfileList() {
        this.profiles = [];
        this.addStateResults();
        this.addCollectionResults();
        this.modelChild.searchReady = true;
        this.cdRef.detectChanges();
    }

    addStateResults() {
        let firstNameProvided = false;
        let firstNameMatch = false;
        let middleNameProvided = false;
        let middleNameMatch = false;
        let lastNameProvided = false;
        let lastNameMatch = false;
        let dobProvided = false;
        let dobMatch = false;
        let dlnProvided = false;
        let dlnMatch = false;
        for (var i in this.currentProfiles) {
            firstNameProvided = false;
            firstNameMatch = false;
            middleNameProvided = false;
            middleNameMatch = false;
            lastNameProvided = false;
            lastNameMatch = false;
            dobProvided = false;
            dobMatch = false;
            dlnProvided = false;
            dlnMatch = false;

            if (this.model.criteria.Indv_First_Name && this.model.criteria.Indv_First_Name != '') {
                firstNameProvided = true;
                if (
                    this.currentProfiles[i].Indv_First_Name &&
                    this.currentProfiles[i].Indv_First_Name.indexOf(this.model.criteria.Indv_First_Name) == 0
                ) {
                    firstNameMatch = true;
                }
            }

            if (this.model.criteria.Indv_Middle_Name && this.model.criteria.Indv_Middle_Name != '') {
                middleNameProvided = true;
                if (
                    this.currentProfiles[i].Indv_Middle_Name &&
                    this.currentProfiles[i].Indv_Middle_Name.indexOf(this.model.criteria.Indv_Middle_Name) == 0
                ) {
                    middleNameMatch = true;
                }
            }

            if (this.model.criteria.Indv_Last_Name && this.model.criteria.Indv_Last_Name != '') {
                lastNameProvided = true;
                if (
                    this.currentProfiles[i].Indv_Last_Name &&
                    this.currentProfiles[i].Indv_Last_Name.indexOf(this.model.criteria.Indv_Last_Name) == 0
                ) {
                    lastNameMatch = true;
                }
            }

            if (this.model.criteria.Birth_Date && this.model.criteria.Birth_Date != '') {
                dobProvided = true;
                if (this.model.criteria.Birth_Date.indexOf('T') > -1) {
                    this.model.criteria.Birth_Date = this.model.criteria.Birth_Date.split('T')[0];
                }
                if (
                    this.currentProfiles[i].Birth_Date &&
                    this.currentProfiles[i].Birth_Date == this.model.criteria.Birth_Date
                ) {
                    dobMatch = true;
                }
            }

            if (this.model.criteria.Drvr_Lic_Num && this.model.criteria.Drvr_Lic_Num != '') {
                dlnProvided = true;
                if (
                    this.currentProfiles[i].Drvr_Lic_Num &&
                    this.currentProfiles[i].Drvr_Lic_Num == this.model.criteria.Drvr_Lic_Num
                ) {
                    dlnMatch = true;
                }
            }

            if (
                ((firstNameProvided && firstNameMatch) || !firstNameProvided) &&
                ((middleNameProvided && middleNameMatch) || !middleNameProvided) &&
                ((lastNameProvided && lastNameMatch) || !lastNameProvided) &&
                ((dobProvided && dobMatch) || !dobProvided) &&
                ((dlnProvided && dlnMatch) || !dlnProvided)
            ) {
                this.profiles.push(this.currentProfiles[i]);
            }
        }
    }

    addCollectionResults() {
        for (var i in this.dsCollection.objectNodes) {
            if (this.dsCollection.objectNodes[i].Contract_ID != this.modelChild.contractID) {
                this.profiles.push(this.dsCollection.objectNodes[i]);
            }
        }
    }

    ngOnDestroy() {
        if (this.dsCollectionSub) {
            this.dsCollectionSub.unsubscribe();
        }
    }

    hasAccessToControlledData() {
        const tableName = 'Contract_Profile';
        const dlColumnName = 'Drvr_Lic_Num';
        const dobColumnName = 'Birth_Date';

        this.canViewDLData = this.app.hasControlledDataRights(tableName, dlColumnName);
        this.canViewDOBData = this.app.hasControlledDataRights(tableName, dobColumnName);
    }
}
